import type { ProductSize } from 'product/types/Product'
import type { Color, Look } from '../../types/Color'

export const getModelSize = ({
	selectedColor,
	selectedLook,
}: {
	selectedColor: Color
	selectedLook: Look
}): string | undefined => {
	if (!selectedLook.modelSizeCode || selectedColor.sizes.length <= 1) {
		return
	}
	const selectedModelSize: Partial<ProductSize> = selectedColor.sizes.find(
		(size) => size.id === selectedLook.modelSizeCode
	) ?? {
		label: selectedLook.modelSizeCode,
	}

	return selectedModelSize?.extraInfo
		? `${selectedModelSize.label} (${selectedModelSize.extraInfo})`
		: selectedModelSize?.label
}
